'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'dog-leashed';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f6d4';
var svgPathData = 'M67.64,3.37,288,168.08V192H239.54L38.17,41.25a16,16,0,0,1-2.8-22.45L45.19,6.18A16,16,0,0,1,67.64,3.37ZM128,224H288V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.1C58.83,268.85,32,233.66,32,192a32,32,0,0,1,64,0A32,32,0,0,0,128,224ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.23-21.39,27.32-11.31L374.6,64h53.62c10.92,0,23.74,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112ZM320,231.84l128,45.71V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H320ZM432,112a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faDogLeashed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;